import { z } from 'zod';

export const accountSelectionSchema = z.object({
  accountId: z.string().min(1, 'Please select an account'),
});

export type AccountSelectionFormValues = z.infer<typeof accountSelectionSchema>;
